module.exports = __webpack_public_path__ + "static/zen-in-the-art-of-archery-e004f760f3a1c05203960f55715ff5ae.jpg";